import TrabalheConosco from "./TrabalheConosco";

const Works = () => {
  return (
    <div>
      <TrabalheConosco />
    </div>
  )
}
export default Works;